import { PORTAL_REQUEST_STATUS_LABELS, type PortalRequestStatus } from '@fos/shared/contracts/portal';
import { Archive, CalendarCheck, Check, Clock, Eye, type LucideIcon, Pause, Wrench } from 'lucide-react';
import { type PillTone, StatusPill } from '../../../ui/StatusPill';

/**
 * Status zgłoszenia w portalu klienta (DECISIONS 2026-10-17 [P] „Model portalu klienta” nr 4) jako pigułka
 * (lifting 17.10.2026). Etykiety z `@fos/shared/contracts/portal`; barwa jak na tablicy zespołu (do sprawdzenia —
 * fiolet jak „Do odbioru”, wstrzymane — bursztyn), a ikona odróżnia statusy w tej samej barwie (osoba klienta nie
 * zna naszych kolumn, więc nie opieramy się na samym kolorze).
 */
const PILL: Record<PortalRequestStatus, { tone: PillTone; icon: LucideIcon }> = {
  received: { tone: 'progress', icon: Clock },
  planned: { tone: 'neutral', icon: CalendarCheck },
  in_progress: { tone: 'progress', icon: Wrench },
  on_hold: { tone: 'waiting', icon: Pause },
  to_check: { tone: 'review', icon: Eye },
  done: { tone: 'done', icon: Check },
  closed: { tone: 'neutral', icon: Archive },
};

/** Jedno zdanie pod statusem w szczegółach: co to znaczy dla osoby klienta. */
export const PORTAL_STATUS_EXPLAINED: Record<PortalRequestStatus, string> = {
  received: 'Zgłoszenie dotarło. Zespół je przejrzy i zaplanuje.',
  planned: 'Zgłoszenie jest zaplanowane do realizacji.',
  in_progress: 'Pracujemy nad tym zgłoszeniem.',
  on_hold: 'Prace są wstrzymane. Jeśli czekamy na coś od Ciebie, napiszemy o tym w rozmowie.',
  to_check: 'Zrobione — sprawdź, proszę, i daj znać w rozmowie, czy wszystko działa.',
  done: 'Zgłoszenie jest zakończone.',
  closed: 'Zgłoszenie jest zamknięte.',
};

export function PortalStatusPill({ status, className }: { status: PortalRequestStatus; className?: string }) {
  const pill = PILL[status];
  return (
    <StatusPill tone={pill.tone} icon={pill.icon} className={className}>
      {PORTAL_REQUEST_STATUS_LABELS[status]}
    </StatusPill>
  );
}
